import {Navigate, Outlet, RouteObject} from 'react-router';

export const helpdeskReportRoutes: RouteObject[] = [
  {
    path: 'reports',
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Navigate to="tickets" replace />,
      },
      {
        path: 'chats',
        lazy: () =>
          import('@app/dashboard/reports/conversations-overview-report-page'),
      },
      {
        path: 'tickets',
        lazy: () =>
          import('@app/dashboard/reports/conversations-overview-report-page'),
      },
      {
        path: 'teammates',
        lazy: () =>
          import('@app/dashboard/reports/team/teammates-performance-report-page'),
      },
      {
        path: 'teammates/:agentId',
        element: <Navigate to="tickets" replace />,
      },
      {
        path: 'teammates/:agentId/chats',
        lazy: () => import('@app/dashboard/reports/team/teammate-report-page'),
      },
      {
        path: 'teammates/:agentId/tickets',
        lazy: () => import('@app/dashboard/reports/team/teammate-report-page'),
      },
      {
        path: 'groups/:groupId/chats',
        lazy: () => import('@app/dashboard/reports/group-report-page'),
      },
      {
        path: 'groups/:groupId/tickets',
        lazy: () => import('@app/dashboard/reports/group-report-page'),
      },
      {
        path: 'campaigns',
        lazy: () =>
          import('@livechat/dashboard/reports/all-campaigns-report-page'),
      },
      {
        path: 'campaigns/:campaignId',
        lazy: () => import('@livechat/dashboard/reports/campaign-report-page'),
      },
      {
        path: 'ai-agent',
        lazy: () => import('@ai/ai-agent/reports/ai-agent-report-page'),
      },
      {
        path: 'tags',
        lazy: () => import('@app/dashboard/reports/tags-report-page'),
      },
      {
        path: 'articles',
        lazy: () => import('@app/dashboard/reports/articles-report-page'),
      },
      {
        path: 'faq-views',
        lazy: () => import('@app/dashboard/reports/faq-views-report-page'),
      },
      {
        path: 'agent-transfers',
        lazy: () =>
          import('@app/dashboard/reports/agent-transfers-report-page'),
      },
      {
        path: 'user-feedback',
        lazy: () => import('@app/dashboard/reports/user-feedback-report-page'),
      },
      {
        path: 'top-intents',
        lazy: () => import('@app/dashboard/reports/top-intents-report-page'),
      },
      {
        path: 'search',
        element: <Navigate to="popular" replace />,
      },
      {
        path: 'search/popular',
        lazy: () =>
          import('@app/dashboard/reports/search-report-page').then(
            ({PopularSearchReportPage}) => ({
              Component: PopularSearchReportPage,
            }),
          ),
      },
      {
        path: 'search/failed',
        lazy: () =>
          import('@app/dashboard/reports/search-report-page').then(
            ({FailedSearchReportPage}) => ({
              Component: FailedSearchReportPage,
            }),
          ),
      },
      {
        path: 'analytics',
        lazy: () =>
          import('@app/dashboard/reports/google-analytics-report-page'),
      },
      {
        path: 'envato',
        lazy: () => import('@app/dashboard/reports/envato-report-page'),
      },
    ],
  },
];
